import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { formatAsCurrency } from '../../../../utils/priceTools'

const CurrentBalanceDetail = ({ amount, className, text }) => (
  <div className={className}>
    <span>{text}:</span>
    <h3>{formatAsCurrency({ amount })}</h3>
  </div>
)

CurrentBalanceDetail.defaultProps = {
  className: '',
}

CurrentBalanceDetail.propTypes = {
  amount: PropTypes.number.isRequired,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
}

const StyledCurrentBalanceDetail = styled(CurrentBalanceDetail)({
  alignItems: 'center',
  display: 'flex',
  flex: '0 0 100%',
  flexWrap: 'wrap',
  marginBottom: '8px',
  h3: {
    marginLeft: '8px',
  },
  '@media(min-width: 1200px)': {
    flex: '0 0 50%',
    justifyContent: 'flex-end',
    '&:first-of-type': {
      justifyContent: 'flex-start',
    },
    '&:last-of-type': {
      marginLeft: 'auto',
    },
  },
})

export default StyledCurrentBalanceDetail
